import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'app-login-layout',
    template: `
        <main class="p-4 pt-8 min-h-screen flex items-baseline justify-center bg-gray-50">
            <router-outlet></router-outlet>
        </main>`,
    styles: [],
    imports: [
        RouterOutlet
    ],
    standalone: true
})
export class LoginLayoutComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
